import {type PaletteOptions} from '@mui/material/styles';

export const ThemeDarkPalette: PaletteOptions = {
  mode: 'dark',
  common: {black: '#010101', white: '#fefefe'},
  text: {
    primary: '#ffffff !important',
    secondary: 'rgba(255, 255, 255, 0.7) !important',
    disabled: 'rgba(255, 255, 255, 0.5) !important',
  },
  primary: {
    light: '#F7B27A',
    main: '#f26722',
    dark: '#B93815',
    contrastText: '#fff',
  },
  secondary: {
    light: '#4d4d4d',
    main: '#4d4d4d',
    dark: '#4d4d4d',
    contrastText: '#fff',
  },
  success: {
    light: '#56B88A',
    main: '#00944F',
    dark: '#006134',
    contrastText: '#fff',
  },
  warning: {
    light: '#FFB657',
    main: '#FF9000',
    dark: '#A85F00',
    contrastText: '#fff',
  },
  error: {
    light: '#F06F66',
    main: '#E9291C',
    dark: '#9B1B12',
    contrastText: '#fff',
  },
  info: {
    light: '#6A9499',
    main: '#064C55',
    dark: '#053D44',
    contrastText: '#fff',
  },
};
